export const rankingItems = [
  { rank: 1, title: '某顶流男星被拍到深夜密会神秘女子，工作室紧急发文澄清', heat: '987万', tag: '爆', trend: 'up' },
  { rank: 2, title: '热播剧男主戏外真恋情曝光，粉丝：原来他俩早就在一起了', heat: '856万', tag: '热', trend: 'up' },
  { rank: 3, title: '知名女星晒孕肚照宣布二胎喜讯，圈内好友纷纷送祝福', heat: '743万', tag: '热', trend: 'up' },
  { rank: 4, title: '综艺节目录制现场突发意外，节目组紧急回应引争议', heat: '621万', tag: '新', trend: 'up' },
  { rank: 5, title: '某选秀冠军被曝欠下巨额债务，昔日辉煌不再令人唏嘘', heat: '558万', tag: '热', trend: 'down' },
  { rank: 6, title: '年度最受期待电影突然撤档，片方给出的理由让网友炸了', heat: '492万', tag: '新', trend: 'up' },
  { rank: 7, title: '网红主播直播间翻车现场，尴尬场面被录屏疯传全网', heat: '435万', tag: '热', trend: 'up' },
];

export const indexItems = [
  { title: '娱乐八卦', desc: '明星恋情、婚姻、家庭最新动态一网打尽', icon: 'ri-star-line', count: '2,341篇' },
  { title: '影视综艺', desc: '热门剧集综艺幕后花絮与争议话题深度追踪', icon: 'ri-movie-2-line', count: '1,876篇' },
  { title: '网红圈', desc: '直播圈、短视频平台网红恩怨与热点事件', icon: 'ri-live-line', count: '1,543篇' },
  { title: '社会热点', desc: '全民关注的争议事件与舆论焦点全记录', icon: 'ri-fire-line', count: '3,102篇' },
  { title: '电竞游戏', desc: '电竞赛事、游戏圈大事件与选手八卦', icon: 'ri-gamepad-line', count: '987篇' },
  { title: '时尚生活', desc: '明星穿搭、生活方式与消费争议话题', icon: 'ri-shirt-line', count: '756篇' },
  { title: '音乐现场', desc: '演唱会事故、音乐节翻车与歌手争议', icon: 'ri-music-2-line', count: '634篇' },
  { title: '体育圈', desc: '运动员场外生活、转会风波与体坛趣闻', icon: 'ri-basketball-line', count: '892篇' },
  { title: '海外吃瓜', desc: '国际娱乐圈与海外社交媒体热门话题搬运', icon: 'ri-global-line', count: '1,234篇' },
];

export const commentItems = [
  { author: '吃瓜不嫌事大', avatar: '匿', time: '3分钟前', content: '真的假的？这个瓜我吃了整整一天了还没消化完，信息量太大了。坐等后续，感觉还有反转！', likes: 2341 },
  { author: '深夜吃瓜人', avatar: '瓜', time: '18分钟前', content: '作为资深吃瓜群众表示，这个比前两天的瓜香多了。建议还没吃的赶紧补课，错过后悔一年。', likes: 1892 },
  { author: '理性吃瓜不站队', avatar: '理', time: '42分钟前', content: '建议大家冷静吃瓜，不要盲目站队。目前双方都没有正式回应，先让子弹飞一会儿。', likes: 1567 },
  { author: '今天也在线吃瓜', avatar: '在', time: '1小时前', content: '吃瓜群真的是我的快乐源泉，每天打开都有新瓜，比追剧还刺激。网站做得越来越好了！', likes: 3201 },
];

export const aboutContent = {
  title: '关于吃瓜群',
  paragraphs: [
    '吃瓜群是一个专注于汇聚全网热门话题与娱乐资讯的免费吃瓜平台。我们致力于为广大的吃瓜群众提供最新、最全、最有趣的八卦内容，无需注册登录，打开即看。',
    '从娱乐明星的情感纠葛到社会热点事件的全网追踪，从影视综艺的幕后八卦到网红圈的恩怨情仇——吃瓜群的编辑团队全天候跟进各大平台的最新动态，确保你不错过任何一个值得关注的瓜。',
    '我们相信，吃瓜不应该是少数人的特权。吃瓜群坚持内容免费开放，用简洁明了的呈现方式让每一位吃瓜群众都能快速了解事件来龙去脉。理性吃瓜、快乐分享，这就是吃瓜群的初心。',
  ],
  stats: [
    { label: '累计更新瓜条', value: '12,580+' },
    { label: '日均访问用户', value: '86万+' },
    { label: '覆盖话题领域', value: '30+' },
  ],
};

export const contactContent = {
  title: '投稿爆料',
  description: '你有独家消息？发现了好瓜想分享给更多吃瓜群众？欢迎通过以下方式联系我们。我们严格保护投稿人隐私，所有爆料均采用匿名处理。',
  email: 'tougao@chiguaqun.com',
  tips: ['投稿内容需真实可靠，请附上可核实的来源信息', '涉及个人隐私的内容将进行脱敏处理后发布', '重大独家爆料一经采用将给予丰厚奖励'],
};

export const updateItems = [
  { date: '2026-07-30', time: '14:32', title: '某经纪公司发布声明否认旗下艺人恋情传闻', badge: '最新' },
  { date: '2026-07-30', time: '11:15', title: '热门综艺录制现场路透曝光，嘉宾阵容引热议', badge: '' },
  { date: '2026-07-30', time: '09:48', title: '知名导演新片开拍，主演阵容首次公开亮相', badge: '' },
  { date: '2026-07-29', time: '22:10', title: '某女星深夜发文疑似回应近期网络传闻', badge: '热议' },
  { date: '2026-07-29', time: '18:45', title: '年度音乐盛典获奖名单提前泄露引发争议', badge: '' },
  { date: '2026-07-29', time: '15:20', title: '游戏主播直播间观众破纪录，弹幕刷屏场面震撼', badge: '' },
  { date: '2026-07-29', time: '10:05', title: '某奢侈品牌代言人更换引发粉丝群体激烈争论', badge: '热议' },
];

export const topicItems = [
  { name: '明星恋情', heat: 'high', count: '4,521' },
  { name: '综艺翻车', heat: 'high', count: '3,892' },
  { name: '电影撤档', heat: 'high', count: '3,456' },
  { name: '直播事故', heat: 'medium', count: '2,987' },
  { name: '代言风波', heat: 'medium', count: '2,654' },
  { name: '选秀争议', heat: 'medium', count: '2,341' },
  { name: '婚变传闻', heat: 'high', count: '2,123' },
  { name: '微博热搜', heat: 'medium', count: '1,987' },
  { name: '饭圈互撕', heat: 'medium', count: '1,823' },
  { name: '品牌翻车', heat: 'low', count: '1,567' },
  { name: '剧透讨论', heat: 'low', count: '1,345' },
];

export const featureItems = [
  { icon: 'ri-flashlight-line', title: '实时追踪', desc: '7×24小时不间断更新，全网热点第一时间送达，绝不让你错过任何精彩瞬间' },
  { icon: 'ri-lock-unlock-line', title: '无需注册', desc: '完全免费开放，无需登录即可浏览所有内容，保护你的隐私安全' },
  { icon: 'ri-file-list-3-line', title: '分类清晰', desc: '按话题领域精心归类，影视、综艺、网红、电竞……快速找到你感兴趣的瓜' },
  { icon: 'ri-shield-check-line', title: '理性吃瓜', desc: '坚持客观呈现事件全貌，多方信息交叉验证，引导理性讨论氛围' },
];

export const appContent = {
  title: '随时随地，掌上吃瓜',
  description: '吃瓜群移动端适配已全面上线。在手机浏览器中打开即可获得流畅的阅读体验，无需下载安装任何App。收藏本站，吃瓜不迷路。',
  features: ['响应式设计，适配所有屏幕尺寸', '极速加载，省流模式自动开启', '手势操作友好，滑动阅读更自然'],
};

export const faqItems = [
  { q: '吃瓜群众是什么意思？', a: '吃瓜群众是网络流行语，源自"前排出售瓜子饮料"的弹幕文化。"吃瓜"意为围观、看热闹，吃瓜群众即指那些在网上关注八卦事件、围观争议话题的普通网民。吃瓜群正是为这类用户打造的一站式内容聚合平台。' },
  { q: '吃瓜群的瓜都是真的吗？', a: '我们的编辑团队会对每一条内容进行多方交叉验证，力求呈现真实可靠的信息。对于尚未证实的传闻，我们会明确标注"待核实"。同时建议各位吃瓜群众保持理性，不要轻信未经证实的消息。' },
  { q: '需要注册账号才能看吗？', a: '完全不需要！吃瓜群所有内容均免费开放，无需注册登录即可浏览全部瓜条、评论和专题。我们相信好内容不应该设置门槛。' },
  { q: '如何投稿或爆料？', a: '你可以通过本页面的"投稿爆料"板块找到我们的联系方式，或者直接发送邮件至投稿邮箱。我们承诺严格保护投稿人隐私，所有爆料均采用匿名处理。' },
  { q: '吃瓜群的内容更新频率如何？', a: '编辑团队全天候跟踪各大平台热点，重大事件通常在发生后30分钟内上线报道。平均每天更新50条以上内容，确保你随时打开都有新瓜可吃。' },
];

export const carouselItems = [
  {
    title: '2026暑期档：影视圈风云录',
    desc: '多部大片撤档、票房争议、演员番位之争……这个夏天比电影本身还要精彩。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20movie%20theater%20exterior%20at%20night%20with%20bright%20neon%20signs%20and%20crowds%2C%20warm%20cinematic%20lighting%2C%20vibrant%20red%20and%20gold%20tones%2C%20modern%20Chinese%20illustration%20style%2C%20clean%20composition%20with%20dramatic%20atmosphere&width=800&height=500&seq=carousel-1&orientation=landscape',
    tag: '深度专题',
  },
  {
    title: '顶流明星恋情盘点：谁才是真正的隐形恋人',
    desc: '从蛛丝马迹中寻找真相，年度最全明星情感状态大起底。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20two%20silhouettes%20standing%20apart%20under%20spotlights%20on%20a%20dark%20stage%2C%20romantic%20yet%20mysterious%20atmosphere%2C%20warm%20pink%20and%20deep%20purple%20tones%2C%20modern%20minimal%20style%2C%20clean%20lines&width=800&height=500&seq=carousel-2&orientation=landscape',
    tag: '独家整理',
  },
  {
    title: '网红直播翻车实录：那些年我们吃过的尴尬瓜',
    desc: '直播间里的名场面回顾，每一个都是社交媒体的经典教材。',
    image: 'https://readdy.ai/api/search-image?query=A%20playful%20illustration%20of%20a%20streaming%20studio%20setup%20with%20colorful%20ring%20lights%20and%20monitors%2C%20chaotic%20yet%20fun%20energy%2C%20bright%20neon%20accents%20against%20dark%20background%2C%20modern%20digital%20art%20style%2C%20vibrant%20composition&width=800&height=500&seq=carousel-3&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '品牌代言翻车全记录：从签约到解约只需要三天',
    desc: '盘点近年品牌与明星合作中最戏剧性的翻车事件，商业与娱乐的碰撞。',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20illustration%20of%20luxury%20brand%20products%20shattering%20like%20glass%20in%20midair%2C%20dramatic%20lighting%20with%20gold%20fragments%2C%20high%20contrast%20editorial%20style%2C%20warm%20amber%20and%20crimson%20tones%2C%20sophisticated%20composition&width=800&height=500&seq=carousel-4&orientation=landscape',
    tag: '商业观察',
  },
  {
    title: '电竞圈的瓜不比赛场差：选手转会背后的江湖恩怨',
    desc: '从训练室到社交媒体，电竞选手们的场外故事比比赛还精彩。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20illustration%20of%20an%20esports%20arena%20with%20colorful%20LED%20lights%20and%20gaming%20setups%2C%20energetic%20atmosphere%2C%20neon%20blue%20and%20magenta%20accents%2C%20modern%20digital%20illustration%20style%2C%20wide%20composition%20with%20crowd%20silhouettes&width=800&height=500&seq=carousel-5&orientation=landscape',
    tag: '深度报道',
  },
];

export const mediaItems = [
  {
    title: '独家专访：资深娱记揭秘娱乐圈"瓜"的生产流程',
    desc: '从业15年的娱乐记者讲述一条八卦新闻从爆料到见报的全过程。',
    image: 'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20a%20journalist%20desk%20with%20papers%20and%20a%20vintage%20typewriter%2C%20warm%20ambient%20lighting%2C%20professional%20yet%20artistic%20atmosphere%2C%20soft%20sepia%20and%20cream%20tones%2C%20modern%20minimal%20style&width=600&height=400&seq=media-1&orientation=landscape',
    icon: 'ri-mic-line',
    duration: '深度访谈',
  },
  {
    title: '吃瓜经济学：一条热门八卦背后价值多少钱？',
    desc: '从流量变现到商业合作，我们算了一笔关于"瓜"的经济账。',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20illustration%20of%20data%20charts%20and%20social%20media%20icons%20floating%20around%20a%20glowing%20center%2C%20warm%20coral%20and%20gold%20accents%2C%20clean%20infographic%20style%2C%20modern%20business%20illustration&width=600&height=400&seq=media-2&orientation=landscape',
    icon: 'ri-bar-chart-line',
    duration: '数据解读',
  },
  {
    title: '从吃瓜到翻车：社交媒体时代的舆论反转案例研究',
    desc: '盘点2026年上半年最令人震惊的五次舆论反转事件。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20illustration%20of%20a%20pendulum%20swinging%20between%20two%20extreme%20sides%2C%20symbolizing%20public%20opinion%20reversal%2C%20warm%20amber%20and%20deep%20red%20contrast%2C%20editorial%20illustration%20style%2C%20bold%20minimal%20composition&width=600&height=400&seq=media-3&orientation=landscape',
    icon: 'ri-loop-left-line',
    duration: '案例分析',
  },
];

export const cardItems = [
  {
    title: '某知名歌手深夜发文疑似回应近期离婚传闻',
    category: '娱乐八卦',
    summary: '一条意味深长的微博引发全网解读，评论区已炸锅……',
    image: 'https://readdy.ai/api/search-image?query=A%20moody%20illustration%20of%20a%20smartphone%20screen%20glowing%20in%20a%20dark%20room%20showing%20social%20media%20feed%2C%20warm%20screen%20light%2C%20contemporary%20digital%20art%20style%2C%20atmospheric%20composition&width=600&height=400&seq=card-1&orientation=landscape',
    time: '2小时前',
    comments: 3421,
  },
  {
    title: '热门综艺录制现场突发状况，导演组临时叫停',
    category: '影视综艺',
    summary: '现场观众爆料：录制中断近一小时，嘉宾表情管理失败……',
    image: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20illustration%20of%20a%20TV%20studio%20with%20cameras%20and%20lighting%20rigs%2C%20tense%20atmosphere%2C%20warm%20studio%20lights%2C%20editorial%20photo%20style%2C%20clean%20composition&width=600&height=400&seq=card-2&orientation=landscape',
    time: '5小时前',
    comments: 2891,
  },
  {
    title: '某国际品牌官宣新代言人，评论区上演粉黑大战',
    category: '代言风波',
    summary: '官宣微博发布仅10分钟，评论区已涌入超过5万条留言……',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20luxury%20brand%20billboard%20on%20a%20busy%20city%20street%2C%20crowd%20gathered%20looking%20up%2C%20warm%20golden%20hour%20lighting%2C%20modern%20urban%20illustration%20style&width=600&height=400&seq=card-3&orientation=landscape',
    time: '8小时前',
    comments: 5234,
  },
  {
    title: '知名游戏主播被曝使用外挂，直播间被封三天',
    category: '电竞游戏',
    summary: '观众逐帧分析视频证据，主播至今未作正面回应……',
    image: 'https://readdy.ai/api/search-image?query=A%20tense%20illustration%20of%20a%20gaming%20setup%20with%20red%20warning%20symbols%20on%20monitor%2C%20dark%20room%20with%20RGB%20lighting%2C%20dramatic%20atmosphere%2C%20modern%20digital%20art%20style%2C%20bold%20composition&width=600&height=400&seq=card-4&orientation=landscape',
    time: '12小时前',
    comments: 1876,
  },
  {
    title: '某选秀节目导师阵容曝光，网友：这配置太豪华了',
    category: '影视综艺',
    summary: '拟邀名单包含多位从未上过综艺的重量级人物……',
    image: 'https://readdy.ai/api/search-image?query=A%20glamorous%20illustration%20of%20a%20talent%20show%20stage%20with%20spotlights%20and%20empty%20judges%20chairs%2C%20anticipation%20atmosphere%2C%20warm%20golden%20spotlights%2C%20elegant%20editorial%20style&width=600&height=400&seq=card-5&orientation=landscape',
    time: '1天前',
    comments: 4567,
  },
  {
    title: '某女星红毯造型引发全网模仿，同款礼服搜索量暴涨',
    category: '时尚生活',
    summary: '从发型到配饰被逐一拆解，淘宝同款销售额破千万……',
    image: 'https://readdy.ai/api/search-image?query=A%20fashion%20illustration%20of%20a%20red%20carpet%20event%20with%20elegant%20gowns%20and%20camera%20flashes%2C%20glamorous%20atmosphere%2C%20warm%20champagne%20and%20gold%20tones%2C%20sophisticated%20editorial%20style&width=600&height=400&seq=card-6&orientation=landscape',
    time: '1天前',
    comments: 2345,
  },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '吃瓜索引', href: '#index' },
  { label: '瓜友热评', href: '#comments' },
  { label: '焦点专题', href: '#carousel' },
  { label: '关于吃瓜群', href: '#about' },
  { label: '常见问答', href: '#faq' },
];